"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIfAnObjectiveIsClosed = exports.getObjectiveState = exports.updateObjAlert = exports.getZpdesActLevel = exports.generateParamStateForDiag = exports.manageExTimeStamp = exports.computeGrapheCoverageDiffDoneMasteredWithInitialTest = exports.computeGrapheCoverageDiffDoneMastered = exports.computeGrapheCoverageBis = exports.computeGrapheCoverage = void 0;
const ai_toolkit_1 = require("@evidenceb/ai-toolkit");
/**
 *
 * @returns graphe_coverage
 */
function computeGrapheCoverage(zpdes) {
    let nbTotalActivites = 0;
    let validatedActivities = 0;
    let validatedActivitiesBis = 0;
    let seenActivities = 0;
    let completedObj = [];
    let notActivatedObj = [];
    for (let ID in zpdes.SSBGs) {
        if (ID == zpdes.main_act) {
            for (let i = 0; i < zpdes.SSBGs[ID].SSB[0].state_bandval.length; i++)
                if (zpdes.SSBGs[ID].SSB[0].state_bandval[i] == 2) {
                    let deactSsbgName = zpdes.SSBGs[ID].param_values[0][i];
                    completedObj.push(deactSsbgName);
                    validatedActivities +=
                        zpdes.SSBGs[deactSsbgName].SSB[0].bandval().length;
                }
                else if (zpdes.SSBGs[ID].SSB[0].state_bandval[i] == 0) {
                    let notActivated = zpdes.SSBGs[ID].param_values[0][i];
                    notActivatedObj.push(notActivated);
                }
        }
        if (ID != zpdes.main_act) {
            nbTotalActivites += zpdes.SSBGs[ID].SSB[0].bandval().length;
            for (let i = 0; i < zpdes.SSBGs[ID].SSB[0].state_bandval.length; i++) {
                let inComplete = 0;
                let notActivatedn = 0;
                for (let idd = 0; idd < completedObj.length; idd++) {
                    if (ID == completedObj[idd]) {
                        inComplete = 1;
                    }
                }
                for (let idd = 0; idd < notActivatedObj.length; idd++) {
                    if (ID == notActivatedObj[idd]) {
                        notActivatedn = 1;
                    }
                }
                if (zpdes.SSBGs[ID].SSB[0].state_bandval[i] == 2) {
                    seenActivities += 1;
                    validatedActivitiesBis += 1;
                    if (inComplete == 0) {
                        validatedActivities += 1;
                    }
                }
                else if (zpdes.SSBGs[ID].SSB[0].state_bandval[i] == 1 &&
                    notActivatedn == 0) {
                    seenActivities += 1;
                }
            }
        }
    }
    let graphe_coverage_rate = (0, ai_toolkit_1.truncate)(validatedActivities / nbTotalActivites);
    //let graphe_coverage_rate = truncate(alreadySeenActivities.size / this.nbOfUniqueActivities);
    return graphe_coverage_rate;
}
exports.computeGrapheCoverage = computeGrapheCoverage;
function computeGrapheCoverageBis(bandvalSate, ontology) {
    let nbValidatedAct = 0;
    let nbAct = 0;
    for (const [ssbId, state] of Object.entries(bandvalSate)) {
        if (!ontology.objectives.includes(ssbId)) {
            nbAct += 1;
            if (state == 2) {
                nbValidatedAct += 1;
            }
        }
    }
    return (0, ai_toolkit_1.truncate)((1.0 * nbValidatedAct) / nbAct);
}
exports.computeGrapheCoverageBis = computeGrapheCoverageBis;
function computeGrapheCoverageDiffDoneMastered(bandvalSate, ontology, acitivtySequence) {
    let nbValidatedAct = 0;
    let nbDone = 0;
    let nbAct = 0;
    for (const [ssbId, state] of Object.entries(bandvalSate)) {
        if (!ontology.objectives.includes(ssbId)) {
            nbAct += 1;
            if (state == 1 &&
                acitivtySequence.some((obj) => obj.activityId == ssbId)) {
                nbDone += 1;
            }
            else if (state == 2) {
                nbValidatedAct += 1;
            }
        }
    }
    return (0.5 * nbDone + 1.0 * nbValidatedAct) / nbAct;
}
exports.computeGrapheCoverageDiffDoneMastered = computeGrapheCoverageDiffDoneMastered;
function computeGrapheCoverageDiffDoneMasteredWithInitialTest(bandvalSate, ontology, acitivtySequence, initialTestActivitySequence = []) {
    let nbValidatedAct = 0;
    let nbDone = 0;
    let nbAct = 0;
    for (const [ssbId, state] of Object.entries(bandvalSate)) {
        if (!ontology.objectives.includes(ssbId)) {
            nbAct += 1;
            if (state == 1 &&
                acitivtySequence.some((obj) => obj.activityId == ssbId)) {
                nbDone += 1;
            }
            else if (state == 2) {
                nbValidatedAct += 1;
            }
        }
    }
    if (ontology.startWithInitialTest) {
        nbAct += 1;
        let nbExoDoneInInitTest = 0;
        for (let i = 0; i <
            Math.min(ontology.initialTestDatas["exercises"].length, initialTestActivitySequence.length); i++) {
            if (initialTestActivitySequence[i].exerciseId ==
                ontology.initialTestDatas["exercises"][i]) {
                nbExoDoneInInitTest += 1;
            }
        }
        nbValidatedAct +=
            nbExoDoneInInitTest / ontology.initialTestDatas["exercises"].length;
    }
    return (0.5 * nbDone + 1.0 * nbValidatedAct) / nbAct;
}
exports.computeGrapheCoverageDiffDoneMasteredWithInitialTest = computeGrapheCoverageDiffDoneMasteredWithInitialTest;
/**
 * Manage timestamp of items (exercises)
 * @param item
 * @returns
 */
function manageExTimeStamp(item) {
    let timeStampToUse = "0";
    if (item.timestamp) {
        timeStampToUse = item.timestamp;
    }
    let actTimestamp = new Date(timeStampToUse);
    let readableTimestamp = actTimestamp.getFullYear() +
        "-" +
        (actTimestamp.getMonth() + 1) +
        "-" +
        actTimestamp.getDate();
    let durationToUse = 0;
    if (item.duration)
        durationToUse = item.duration;
    return {
        refDate: readableTimestamp,
        timestamp: timeStampToUse,
        duration: durationToUse,
    };
}
exports.manageExTimeStamp = manageExTimeStamp;
function generateParamStateForDiag(zpdes) {
    let param_state = {};
    for (let ID in zpdes.SSBGs) {
        param_state[ID] = [zpdes.SSBGs[ID].SSB[0].state_bandval];
    }
    return param_state;
}
exports.generateParamStateForDiag = generateParamStateForDiag;
function getZpdesActLevel(zpdes, ObjId, ActIdx) {
    return zpdes.SSBGs[ObjId].SSB[0].relative_lvl[ActIdx];
}
exports.getZpdesActLevel = getZpdesActLevel;
function updateObjAlert(activities, nbStepMax = 4, thresHoldAlert = 0.3) {
    let alertTypes = ["negative", "positive", "none"];
    let exAlertArray = [];
    activities.forEach((element) => (exAlertArray = exAlertArray.concat(element.exercises
        .slice(Math.max(0, element.exercises.length - nbStepMax), element.exercises.length)
        .map((e) => e.success.alert))));
    for (let alert of alertTypes) {
        if (exAlertArray.filter((a) => a == alert).length / exAlertArray.length >
            thresHoldAlert)
            return alert;
    }
}
exports.updateObjAlert = updateObjAlert;
function getObjectiveState(bandvalState, ontology) {
    let listOfObjectives = ontology.objectives;
    let listOfObjectivesState = {};
    for (let objId of listOfObjectives) {
        listOfObjectivesState[objId] = bandvalState[objId];
    }
    return listOfObjectivesState;
}
exports.getObjectiveState = getObjectiveState;
function checkIfAnObjectiveIsClosed(bandvalState, ontology) {
    return Object.values(getObjectiveState(bandvalState, ontology)).includes(2);
}
exports.checkIfAnObjectiveIsClosed = checkIfAnObjectiveIsClosed;
